import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getProducts, setOptions } from "../../store/reducers/filterSlice";

class Option extends React.Component {
  state = {
    option: {},
    selected: false,
    initialValues: [],
  };

  constructor(props) {
    super(props);

    this.state.initialValues = JSON.parse(
      JSON.stringify(this.props.option.values)
    );

    this.toggleOption = (value) => {
      this.props.setOptions({ option: this.props.option.option, value: value });
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.option.values != this.props.option.values) {
      this.setState({
        initialValues: JSON.parse(JSON.stringify(this.props.option.values)),
      });
    }
  }
  isSelected(value) {
    const options = this.props.options;

    return (
      !!options[this.props.option.option] &&
      options[this.props.option.option].includes(value)
    );
  }
  isDisabled(value) {
    const inList = this.props.option.values.find((el) => el.value == value);

    return !!!inList;
  }
  render() {
    return (
      <>
        <li data-filter-part="item-container">
          <span
            className={
              `radio-container ${
                this.props.option.values.length < 1 ? "empty" : ""
              }` + `${this.state.selected == true ? " selected" : ""}`
            }
            onClick={(e) => {
              this.setState({ selected: !this.state.selected });
            }}
          >
            <a>{this.props.option.title}</a>
          </span>
          <ul
            className={
              "l2 option-" +
              this.props.option.option +
              `${this.state.selected == true ? " selected" : ""}`
            }
            data-filter-part="item-children-container"
          >
            {this.state.initialValues.map((value) => (
              <li key={value.id}>
                <input
                  type="checkbox"
                  className={this.isDisabled(value.value) ? "disabled" : ""}
                  checked={this.isSelected(value.value)}
                  disabled={this.isDisabled(value.value)}
                  onChange={(e) => this.toggleOption(value.value)}
                  id={"f-opt-" + value.id}
                  value={value.value}
                />
                <label htmlFor={"f-opt-" + value.id}>{value.value}</label>
              </li>
            ))}
          </ul>
        </li>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    options: state.filter.request.options,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setOptions: (args) => (dispatch) => {
        dispatch(setOptions(args));
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Option);
